module.exports = __webpack_public_path__ + "images/emoji/virgo.8ee9be02240498b2424d.png";